module.exports = __webpack_public_path__ + "img/beefeater-first-block-img-mobile.9c4aa6a6.png";